import { useQuery } from '@tanstack/react-query';
import { getAllPosts, getPostBySlug } from '../api/blog';
import { BlogPost } from '../blog';

export function useBlogPosts() {
    return useQuery<BlogPost[]>({
        queryKey: ['blog'],
        queryFn: getAllPosts,
    });
}

export function useBlogPost(slug: string) {
    return useQuery<BlogPost | null>({
        queryKey: ['blog', slug],
        queryFn: () => getPostBySlug(slug),
        enabled: !!slug,
    });
}

